<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_xiii"></a><a id="ack"></a>Acknowledgements</h2>
<p class="para">It’s often that said that it takes a village to raise a child and the birthing and raising of a new book from concept to market requires a similar collaborative effort. Each of us offers sincere thanks to our coauthors and to David Hancock and his publishing team at Morgan James. The input from Jim Howard, Margo Toulouse and Bethany Marshall was invaluable in crafting a much better book for our readers.</p>
<p class="indent-para">Thanks also go out to Frank Deardurff for a great cover design and for putting up with our seemingly dozens of cover modifications as we moved along. Your patience and professionalism are most appreciated.</p>
<p class="indent-para">All three of us would like to thank our wives for well, putting up with each of us. To Robbi, Karen and Jessika, thank you for your continued support and for always being there for us.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?4cb5f444